// TabContent1.js
import React, { useState, useEffect } from 'react';
import ProgressionTab from '../../../../theme/ProgressionBuilder/ProgressionTab';
import Subheading from '../../../../theme/text/Subheading';
import SelectGroup from '../../../../theme/Select/SelectGroup';
import NumberInput from '../../../../theme/inputs/NumberInput';
import { useTheme } from '@emotion/react';
import Text from '../../../../theme/text/Text';
import { useTranslation } from 'react-i18next';
import { Box, InputBase } from '@mui/material';
import { tokens } from '../../../../../theme';
import { useSelector } from 'react-redux';
import * as yup from "yup";
import ShValidatedInput from '../../../../theme/inputs/ShValidatedInput';
import { yupRequired } from '../../../../../utils/validation';
import { setTabErrors } from '../../../../../newapi/global/progressionTabSlice';
import { useDispatch } from 'react-redux';
import { InputDropdown } from '../../../../theme/dropdowns/InputDropdown';
import { useGetWarehousesSelectQuery } from '../../../../../newapi/warehouse/warehouseApiSlice';


/**
 * TabContent1 Component
 * 
 * Props:
 * - handleDataUpdate: Function, updates the data in the Redux state.
 * - handleNext: Function, navigates to the next tab.
 */
const Content = (props) => {
    const theme = useTheme();
    const {t} = useTranslation();
    const colors = tokens(theme.palette.mode);
    const data = { ...props.data };
    const [fieldErrors, setFieldErrors] = useState({});
    const dispatch = useDispatch();
    const { data: warehouses } = useGetWarehousesSelectQuery();
    const selectedActiveWarehouseId = useSelector(state => state.warehouse.activeId);

    const handleChange = (key, val) => {
        props.handleDataUpdate({ [key]: val });
        dispatch(setTabErrors({ ...props.errors, [key]: '' }));
    };
    
    useEffect(() => {
        if (warehouses?.data.length === 1) {
            handleChange("warehouses", [warehouses.data[0].id])
        } else {
            if(selectedActiveWarehouseId !== -1){
                handleChange("warehouses",[selectedActiveWarehouseId])
            }

        }
    }, [warehouses,selectedActiveWarehouseId])

    return (
        <>
            <Box 
                sx={{
                    width:1,
                    paddingTop: 2,
                    display:"flex",
                    alignItems:"center",
                    justifyContent:"space-between",
                    gap:7
                }}
            >

                <Box
                    sx={{
                        width:120,
                    }}
                >
                    <Text>{t("name")}</Text>
                </Box>
                
                
                    <ShValidatedInput
                            name="name"
                            value={data.name ?? ""}
                            onChange={handleChange}
                            error={props.errors.name}
                        />
            </Box>
            <Box 
                sx={{
                    width:1,
                    paddingTop: 2,
                    display:"flex",
                    alignItems:"center",
                    justifyContent:"space-between",
                    gap:7
                }}
            >

                <Box
                    sx={{
                        width:120,
                    }}
                >
                    <Text>{t("warehouses")}</Text>
                </Box>
                
                
                <InputDropdown
                        key={data?.warehouses}
                        name="warehouses"
                        displayName="name"
                        changeField="id"
                        valueKey="id"
                        multiple
                        selected={data?.warehouses ?? []}
                        options={warehouses?.data ?? []}
                        noSelection={t("choose_warehouses")} 
                        onChange={(val) => handleChange("warehouses",val)}
                    />
            </Box>
        </>
    );
};

const ShipperBasicInfo = (props) => {
    const { t } = useTranslation();
    const schema = yup.object({
        name: yupRequired('name',t),
    });
    
    const { maxSteps } = useSelector((state) => state.progressiontabs);

    return (
        <ProgressionTab 
            tabId="tabBasicInfo" 
            subtitle={"Info"} 
            step={2}
            nextTab={"tabMeasurements"}
            maxSteps={maxSteps}
            schema={schema}
        >
            <Content />
        </ProgressionTab>
    )
}

export default ShipperBasicInfo;

